import * as React from 'react';
import * as styles from './Promo.css';

interface IPromoProps {
  promo: React.ReactElement;
  link: React.ReactElement;
  previews?: React.ReactNode;
}

export const Promo = ({ promo, link, previews }: IPromoProps) => {
  return (
    <div className={styles['container']}>
      <div className={styles['layout']}>
        <div className={styles['promo']}>{promo}</div>
        {previews && <div className={styles['previews']}>{previews}</div>}
        <div>{link}</div>
      </div>
    </div>
  );
};
